import type { WebTrpcClient } from '../trpc/client.js';
import type { AnalyticsReadPort } from './AnalyticsReadPort.js';

/** Cookie-authenticated production adapter for the analytics read boundary. */
export class TrpcAnalyticsReadAdapter implements AnalyticsReadPort {
  constructor(private readonly client: WebTrpcClient) {}

  dashboard: AnalyticsReadPort['dashboard'] = (input) =>
    this.client.admin.analytics.dashboard.query(input);
  metricDetail: AnalyticsReadPort['metricDetail'] = (input) =>
    this.client.admin.analytics.metricDetail.query(input);
  pages: AnalyticsReadPort['pages'] = (input) => this.client.admin.analytics.pages.query(input);
  export: AnalyticsReadPort['export'] = (input) => this.client.admin.analytics.export.mutate(input);
}
